import { makeStyles } from '@material-ui/core/styles';

export const useAssistantActionsStyles = makeStyles(theme => ({
  newChatButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(1, 1),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(2)
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  searchButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(1, 1),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(2)
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));
